import merge from 'deepmerge';

interface OAuthConfig {
  scope: string;
  client_id: string;
  response_type: string;
  redirect_uri: string;
  authorization?: string;
  token?: string;
}

interface AppConfig {
  appName: string;
  appFullName: string;
  oAuth: OAuthConfig;
  apiUrl?: string;
  workspace?: string;
}

const isDev = () =>
  window.location.origin.includes('dev') ||
  window.location.origin.includes('localhost:');

const isPreProd = () => window.location.origin.includes('preprod');
const isStaging = () => window.location.origin.includes('staging');

const base = {
  appName: 'cpp-portal',
  appFullName: 'CPP Portal',
  oAuth: {
    scope: 'profile openid email connected_product:connectedid.qrredirect.admin::read:',
    client_id: 'nike.niketech.qr-redirect-automation',
    response_type: 'authorization_code',
    redirect_uri: window.location.origin + '/'
  }
};

const dev = merge(base, {
  apiUrl: 'https://your-dev-api-url.com',
  oAuth: {
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize',
    token: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/token'
  },
  workspace: 'dev'
});

const preprod = merge(base, {
  apiUrl: 'https://your-preprod-api-url.com',
  oAuth: {
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize',
    token: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/token'
  },
  workspace: 'preprod'
});

const staging = merge(base, {
  apiUrl: 'https://your-staging-api-url.com',
  oAuth: {
    authorization: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize',
    token: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/token'
  },
  workspace: 'staging'
});

const prod = merge(base, {
  apiUrl: 'https://your-prod-api-url.com',
  oAuth: {
    authorization: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize',
    token: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/token'
  },
  workspace: 'prod'
});

let config: AppConfig;
if (isPreProd()) {
  config = preprod;
} else if (isDev()) {
  config = dev;
} else if (isStaging()) {
  config = staging;
} else {
  config = prod;
}

export type { AppConfig, OAuthConfig };
export default config;

